import React from "react";
import Image from "next/image";

function preprocessUrl(url) {
  url = url.trim();
  if (!url.includes("?") && url.includes("&")) {
    const firstAmpIndex = url.indexOf("&");
    url = url.slice(0, firstAmpIndex) + "?" + url.slice(firstAmpIndex + 1);
  }
  return url;
}

const ImageComponent = (props) => {
  const src = preprocessUrl(props.src);

  return (
    <Image
      {...props}
      src={encodeURI(src)}
      alt={props.alt || "image"}
      priority
    />
  );
};

export default ImageComponent;
